import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "remote-monitoring-event__buttons-delimiter" }, null, -1)
const _hoisted_2 = { class: "remote-monitoring-events__items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_FilterDateRange = _resolveComponent("FilterDateRange")!
  const _component_CardSelect = _resolveComponent("CardSelect")!
  const _component_NBaseBar = _resolveComponent("NBaseBar")!
  const _component_RemoteMonitoringEventItem = _resolveComponent("RemoteMonitoringEventItem")!
  const _component_ImageViewer = _resolveComponent("ImageViewer")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    state: _ctx.state,
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    statistics: false
  }, {
    filters: _withCtx(() => [
      _createVNode(_component_NBaseBar, null, {
        start: _withCtx(() => [
          _createVNode(_component_NButton, {
            type: "secondary",
            onClick: _ctx.acknowledgeAll
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('remote_monitoring.acknowledge_all', 'f')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_1,
          _createVNode(_component_NButton, {
            type: "secondary",
            onClick: _ctx.togglePlaying,
            icon: _ctx.playing ? 'pause' : 'play'
          }, null, 8, ["onClick", "icon"]),
          (!_ctx.playing)
            ? (_openBlock(), _createBlock(_component_NButton, {
                key: 0,
                type: "secondary",
                onClick: _ctx.refresh,
                counter: _ctx.newEvents.length
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('remote_monitoring.new_events', 'f')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "counter"]))
            : _createCommentVNode("", true)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_FilterDateRange, {
            "clear-button": false,
            "has-intervals": false,
            model: _ctx.currentFilter,
            "gte-prop": "event_timestamp_gte",
            "lte-prop": "event_timestamp_lte"
          }, null, 8, ["model"]),
          _createVNode(_component_CardSelect, {
            modelValue: _ctx.currentFilter.card,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentFilter.card) = $event)),
            idIn: _ctx.monitoringModule.getCardIds()
          }, null, 8, ["modelValue", "idIn"])
        ]),
        _: 1
      })
    ]),
    items: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_RemoteMonitoringEventItem, {
            key: item.id,
            item: item,
            reasons: _ctx.monitoringModule.getReasonsByCardId(item.card),
            onShowImage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleViewer($event)))
          }, null, 8, ["item", "reasons"]))
        }), 128))
      ])
    ]),
    "image-viewer": _withCtx(() => [
      (_ctx.viewerItem)
        ? (_openBlock(), _createBlock(_component_ImageViewer, {
            key: 0,
            bboxes: _ctx.viewerItem.bboxes,
            src: _ctx.viewerItem.src,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleViewer()))
          }, null, 8, ["bboxes", "src"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["state", "onUpdate:scrollBottom"]))
}